// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2O1Xt","importantInfo":"styles_importantInfo__ushAk"};